import { React, useEffect } from 'react';
import logo from './img/gap.png';
import logoE from './img/edaplogo.png';
import logoD from './DPHU/img/lgo.png';
import logoG from './GOMA/img/lgo.png';
import logoU from './UNIKAL/img/lgo.png';
import logoK from './KISANGANI/img/lgo.png';
import logoM from './MUKEDI/img/lgo2.png';
import logoA from './UNIM/img/logo.png';
import logoS from './ISTAM/img/edaplogo.png';
import logound from './UND/img/edaplogo.png';
import logouncr from './UNCR/img/edaplogo.png';
import logoCierha from './CIERHA/CIERHA_Logo.png';

export default function Super() {

  useEffect(() => {
    document.title = 'General AdmiDash';
  }, []);

  return (
    <div className='Super'>
      <h1>General Admin Dashboard</h1>
      <p>Access to all Schools & Universities</p>
      <div className='link-container'>
        <a href="/admin">LOGIN</a>
        <img src={logo} alt="EDAP Logo" className="hover-image" />
      </div> <br />
      <div className='link-container'>
        <a href="/admin">EDAP</a>
        <img src={logoE} alt="EDAP Logo" className="hover-image" />
      </div>
      <div className='link-container'>
        <a href="/adminDPHU">DPHU</a>
        <img src={logoD} alt="DPHU Logo" className="hover-image" />
      </div>
      <div className='link-container'>
        <a href="/adminGOMA">GOMA</a>
        <img src={logoG} alt="GOMA Logo" className="hover-image" />
      </div>
      <div className='link-container'>
        <a href="/adminUNIKAL">UNIKAL</a>
        <img src={logoU} alt="UNIKAL Logo" className="hover-image" />
      </div>
      <div className='link-container'>
        <a href="/adminKISA">KISANGANI</a>
        <img src={logoK} alt="KISANGANI Logo" className="hover-image" />
      </div>
      <br />
      <div className='link-container'>
        <a href="/adminMUKEDI">MUKEDI</a>
        <img src={logoM} alt="MUKEDI Logo" className="hover-image" />
      </div>
      <div className='link-container'>
        <a href="/adminUNIM">UNIM</a>
        <img src={logoA} alt="MUKEDI Logo" className="hover-image" />
      </div>
      <div className='link-container'>
        <a href="/adminISTAM">ISTAM</a>
        <img src={logoS} alt="MUKEDI Logo" className="hover-image" />
      </div>
      <div className='link-container'>
        <a href="/adminUND">UND</a>
        <img src={logound} alt="UND Logo" className="hover-image" />
      </div>
      <div className='link-container'>
        <a href="/adminUNCR">UNCR</a>
        <img src={logouncr} alt="UNCR Logo" className="hover-image" />
      </div>
      <div className='link-container'>
        <a href="/adminCIERHA">CIERHA</a>
        <img src={logoCierha} alt="CIERHA Logo" className="hover-image" />
      </div>
    </div>
  );
}
